import { useParams } from "react-router-dom";

// sempre usar caminho absoluto RELATIVO AO "pages"
import CadastroFeinsulVisitante from "./feinsul/CadastroVisitante";
import CadastroFeinsulExpositor from "./feinsul/CadastroExpositor";

import CadastroNovoVisitante from "./raizes/CadastroVisitante";

export default function CadastroRouter() {
  const { id, tipo } = useParams();

  if (id === "feinsul-2026") {
    if (tipo === "visitante") return <CadastroFeinsulVisitante />;
    if (tipo === "expositor") return <CadastroFeinsulExpositor />;
  }

    if (id === "EntreNos" && tipo === "visitante") {
    return <CadastroNovoVisitante />;
  }

  return <div>Evento não encontrado</div>;
}